import { render, staticRenderFns } from "./type-button.vue?vue&type=template&id=1d0a981d&scoped=true&"
import script from "./type-button.vue?vue&type=script&lang=js&"
export * from "./type-button.vue?vue&type=script&lang=js&"
import style0 from "./type-button.vue?vue&type=style&index=0&id=1d0a981d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a981d",
  null
  
)

export default component.exports